import { createLightTheme, BrandVariants } from "@fluentui/react-components";

const fearnleysBrandRamp: BrandVariants = {
  10: "#05090c",
  20: "#080e12",
  30: "#0b1218",
  40: "#0e171e",
  50: "#101c23",
  60: "#132029",
  70: "#16252f",
  80: "#1b2e3b",
  90: "#32434f",
  100: "#495862",
  110: "#5f6d76",
  120: "#768289",
  130: "#8d979d",
  140: "#a4abb1",
  150: "#bbc0c4",
  160: "#d1d5d8",
};

export const fearnleysLightTheme = createLightTheme(fearnleysBrandRamp);
